export default "__VITE_ASSET__q$RlIlV4__"